import React, { Component } from 'react'
import { withDomains, RESTExecutor } from '../../lib/domain'
import { Link } from 'react-router-dom';
import { Typography, Table, Row, Button, Divider, Input, Spin, Tag, Badge, message, Space, Popconfirm } from 'antd';
import { showErrorInNotification, NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, showSuccessInNotification, formatMoney, schema_to_field } from '../../lib/util';
import ErrorWrapper from '../../lib/error_wrapper';
import { BasicHeader } from '../../components/basic_header';
import { StarOutlined, StarBorder, StorageOutlined, InsertDriveFileOutlined, LayersOutlined, WifiTetheringOutlined, KitchenOutlined, DnsOutlined } from '@material-ui/icons';
import { TransparentButton } from '../../components/basic_items';
import { PopUpForm } from '../../lib/ui/popupform';
import DayDifferennceTag from '../../components/day_difference_tag';
const queryString = require('query-string');

const { Title, Paragraph, Text } = Typography;

class RepositoryList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filter_query: {},
            selected_repo: null,
            form_data: {},
            selected_id: null,
            run_schema: [],
            form_visibility: false,
            extra_params: {}

        };
        this.list_repositories = RESTExecutor.list().config({
            label: 'repository_list',
            params: {
                per_page: 100
            }
        }).connect(props.domains.fetcher);

        this.upload_data = RESTExecutor.post().config({
            label: 'repository_upload'
        }).callbacks((success) => {
            this.setState({
                selected_repo: null,
                form_data: {}
            });
            message.success("File Uploaded")
        }).connect(props.domains.fetcher);

        this.run_fetcher = RESTExecutor.post().config({
            label: 'repository_run'
        }).callbacks((success) => {
            showSuccessInNotification(success);
            this.setState({
                selected_id: null,
                run_schema: [],
                form_visibility: false,
                extra_params: {}
            })
            try {
                this.loading_message();
            } catch (e) {

            }

        }, (error) => {
            try {
                this.loading_message();
            } catch (e) {

            }
            showErrorInNotification(error);
        }).connect(props.domains.fetcher);








        this.delay_search = new NetworkDelaySearch();




    };

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }



    render() {
        let list_repositories_resp = this.list_repositories.response();
        let upload_data_resp = this.upload_data.response();
        let list_repositories_data = list_repositories_resp.result || {};
        let run_fetcher_resp = this.run_fetcher.response();

        let rowsData = list_repositories_data.rows || [];
        let rowsMeta = list_repositories_resp.meta || {};
        const { filter_query, selected_repo, run_schema, selected_id, form_visibility, extra_params } = this.state;

        return (
            <ErrorWrapper
                error={list_repositories_resp}
                onReload={() => {
                    this.list_repositories.execute()
                }}>
                <BasicHeader
                    no_back
                    title="Fetchers"
                    menu_items={[]}


                />

                <PopUpForm
                    title={`Fill Up Additional Information`}
                    show_title_only
                    forCreate={true}
                    initialData={this.state.extra_params}
                    fields={run_schema}
                    open={form_visibility}
                    networkState={run_fetcher_resp}
                    onClose={() => this.setState({ selected_id: null, extra_params: {}, run_schema: [], form_visibility: false })}
                    onSubmit={(data) => {
                        console.log("DATA", data);
                        this.loading_message = message.loading(`Running Fetcher for Repository`, 0);
                        this.run_fetcher.forId(selected_id).execute(data);
                        // this.handlePostPatch(data);
                    }} />

                <PopUpForm
                    title={`File Upload For ${selected_repo && selected_repo.name}`}
                    stringyfy={false}
                    show_title_only
                    forCreate={true}
                    initialData={this.state.form_data}
                    fields={[
                        { index: 'file', name: "File", type: 'file', compress: true },
                    ]}
                    open={selected_repo != null}
                    networkState={upload_data_resp}
                    onClose={() => this.setState({ selected_repo: null, form_data: {} })}
                    onSubmit={(data) => {
                        console.log("DATA", data);
                        if (!data.file) {
                            message.warn("Cannot upload empty data...");
                            return;
                        } else {
                            let _formdata = new FormData();
                            Object.keys(data).map((key) => {
                                _formdata.append(key, data[key])
                            })
                            this.upload_data.forId(selected_repo.id).execute(_formdata);
                            //   message.warn("END POINT NOT MADE")
                            // this.upload_data.forId(this.datatype).execute(_formdata);
                        }
                        // this.handlePostPatch(data);
                    }} />
                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                        <Input.Search
                            placeholder="Search For"
                            style={{
                            }} autoFocus
                            value={filter_query.query}
                            onChange={(e) => {
                                this.stateUpdater({
                                    stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                                        this.delay_search.onSearch(() => {

                                            this.props.history.push({
                                                // pathname:"users",
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                            })
                                        })

                                    }
                                })
                            }} />
                    </div>
                </div>


                <div className='default-card' style={{
                    // padding: 8
                }}>
                    <Table
                        // rowClassName='hand-cursor'
                        className='main-table noHover'
                        loading={list_repositories_resp.fetching}
                        size='small'
                        scroll={{ x: true }}
                        pagination={{
                            // simple: true,
                            position: 'bottom',
                            onChange: (current, size) => {
                                this.props.history.push({
                                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                })

                            },
                            defaultCurrent: 1,
                            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                            // defaultPageSize: 20,
                            pageSize: (rowsMeta && rowsMeta.requested_count),

                            total: (rowsMeta && rowsMeta.total_count),
                            showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${formatMoney(total, 0)} items`
                        }}
                        rowKey={(record) => record.id}
                        columns={[
                            { title: "NAME", dataIndex: 'name', key: 'name', className: 'bold-cell' },
                            {
                                title: "Fetcher", dataIndex: 'fetcher', key: 'fetcher', width: 200, render: (value, record) => {
                                    return value || record.fetcher_id
                                }
                            },
                            {
                                title: "", dataIndex: "id", key: 'id', width: 400, render: (id, data) => {
                                    return <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }}>
                                        <Link to={`/activity/fetcher/${id}/logs`} style={{ color: 'inherit' }}>
                                            <TransparentButton
                                                className='cta-normal'
                                                label="Logs"
                                                icon={<KitchenOutlined className='btn-icon' />}
                                            />
                                            {/* <Button icon='container' className='cta-basic' type='link'>Packets</Button> */}
                                        </Link>
                                        <Divider type='vertical' />
                                        <Link to={`/activity/fetcher/${id}/responses`} style={{ color: 'inherit' }}>
                                            <TransparentButton
                                                className='cta-normal'
                                                label="Responses"
                                                icon={<DnsOutlined className='btn-icon' />}
                                            />
                                            {/* <Button icon='file' className='cta-basic' type='link'>Files</Button> */}
                                        </Link>

                                    </div>
                                }
                            },
                            {
                                title: "LAST FETCHED", dataIndex: 'executed_at', key: 'executed_at', width: 120,
                                className: 'center-align',
                                render: (value, record) => <div style={{
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}><DayDifferennceTag date={value} /></div>
                            },
                            {
                                title: "ACTION", dataIndex: 'id', key: 'action', className: 'center-align', width: 50,
                                render: (id, data) => {
                                    let need_more_params = false;
                                    if (Array.isArray(data.on_run_config) && data.on_run_config.length > 0) {
                                        need_more_params = true;
                                    }
                                    return data.write_flag ? <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }}>
                                        <Space size={8}>
                                            <Button onClick={() => {
                                                this.setState({ selected_repo: data })
                                            }} type='link'>Upload</Button>
                                            {need_more_params ?
                                                <Button onClick={() => {
                                                    this.setState({
                                                        selected_id: data.id,
                                                        run_schema: schema_to_field(data.on_run_config),
                                                        form_visibility: true
                                                    })
                                                    // this.setState({ selected_repo: data })

                                                }} type='link'>Run</Button> :
                                                <Popconfirm
                                                    placement='bottomRight'
                                                    onConfirm={() => {
                                                        this.loading_message = message.loading(`Running Fetcher ${data.fetcher} for Repository ${data.name}`, 0);
                                                        this.run_fetcher.forId(id).execute();
                                                    }}
                                                    title="Are you sure you want to run this fetcher?">
                                                    <Button onClick={() => {

                                                        // this.setState({ selected_repo: data })

                                                    }} type='link'>Run</Button>
                                                </Popconfirm>
                                            }
                                        </Space>

                                    </div> : null
                                }
                            }
                        ]}
                        dataSource={rowsData}
                    />
                </div>
            </ErrorWrapper>
        )
    }

    componentDidMount() {
        // this.list_repositories.execute();
        overrideHeaderTitle("Datatype List");
        overrideHeaderBack(null);
        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            }
        }, () => {
            this.list_repositories.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })

    }
    componentWillUnmount() {
    }
    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...new_filter_query
                }
            }, () => {
                this.list_repositories.config({
                    params: {
                        ...this.state.filter_query
                    }
                }).execute()
            })
        } else {
            //   this.list_logs.execute()
        }


    }
}

export default withDomains(RepositoryList, "fetcher")


